import { Layout } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import { withRouter } from "react-router-dom";
const { Content } = Layout;

const OrderLayout = ({
  children,
}: {
  children: ReactElement;
}): ReactElement => {
  return (
    <React.Fragment>
      <Layout>
        <Content className="main-content-layout">{children}</Content>
      </Layout>
    </React.Fragment>
  );
};

OrderLayout.propType = {
  children: PropTypes.element,
};

export default withRouter(OrderLayout as any);
